import config from "../../vc/src/config";
import {isSafariOnIOS, resumePlay} from "./ios-safari";
import mockConsole = require("mockconsole");

const logger = config.debugFullScreen ? console : mockConsole;
const errSend = window.__err_send || ((e: any) => logger.error("Error is not sent", e));

const methods: FullScreenMethod[] = [
    "requestFullscreen",
    "mozRequestFullScreen",
    "msRequestFullScreen",
    "webkitEnterFullscreen",
    // "webkitEnterFullScreen",
];

export async function elementToFullScreen(element: HTMLElement): Promise<any> {
    for (const method of methods) {
        const potentialMethod = element[method];
        if (potentialMethod) {
            try {
                return await potentialMethod.call(element);
            } catch (e) {
                console.error("FullScreen", e, element);

                throw e;
            }
        }
    }

    throw "No fullscreen methods found";
}

export function toFullScreen(container?: HTMLElement, video?: HTMLVideoElement) {
    logger.info("FullScreen", "Попытка развернуть на полный экран", container);
    if (container) {
        elementToFullScreen(container)
            .then(
                () => logger.info("FullScreen", "Успешно"),
                err => {
                    // Попытка развернуть video вместо div для iPhone
                    logger.info("FullScreen", "Контейнер развернуть не удалось", err);
                    logger.info("FullScreen", "Попытка развернуть видео", video);

                    if (video) {
                        video.onfullscreenchange = () => {
                            video.controls = isFullScreenElement(video);
                        };
                        video.onfullscreenerror = () => {
                            video.controls = isFullScreenElement(video);
                        };

                        if (isSafariOnIOS()) {
                            $(video).on("webkitendfullscreen", () => resumePlay(video));
                        }

                        elementToFullScreen(video)
                            .then(
                                () => logger.info("FullScreen", "Успешно"),
                                err => {
                                    errSend(err);
                                    console.error("FullScreen on video is also not supported", err);
                                },
                            );
                    }
                },
            );
    }
}


const fsProps: FullScreenProp[] = [
    "fullscreenElement",
    "webkitFullscreenElement",
    "mozFullScreenElement",
    "msFullscreenElement",
];

export function isFullScreenElement(element?: HTMLElement): boolean {
    if (!element) {
        return false;
    }

    for (const prop of fsProps) {
        if (document[prop] === element) {
            return true;
        }
    }

    return element.webkitDisplayingFullscreen || false;
}

export function isFullScreenSupported(element?: HTMLVideoElement) {
    if (!element) {
        return false;
    }

    if (element.webkitSupportsFullscreen === undefined) {
        logger.info("FullScreen", "Is not Webkit. Assuming full screen is supported");
        return true;
    } else {
        logger.info(
            "FullScreen",
            "Is Webkit. Using webkitSupportsFullscreen",
            element,
            element.webkitSupportsFullscreen,
        );

        return element.webkitSupportsFullscreen;
    }
}
